var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLemanaPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF8900",
    d: "m29.047 8.496-5.74 8.265 5.193 5.13v8.022H17.366L15.5 38.499H38.5V17.843z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#815F00",
    d: "m21.999 15.464 7.048-6.968-5.743 8.259zM15.499 29.91v8.587l1.868-8.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDC300",
    d: "M22.001 1.526 5.5 17.842v20.656h10V21.89l6.501-6.427 7.048-6.968z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLemanaPro);
export default __webpack_public_path__ + "static/media/iconLemanaPro.5ec441921e49df8cdd7734628f64d73b.svg";
export { ForwardRef as ReactComponent };